import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Timeline from 'Common/Timeline/Timeline.jsx';
import IconCard from 'Common/Cards/IconCard';
import { loadVersionHistoryData, downloadFile } from 'Actions/submission';
import { getAttachmentTitle } from 'Utils';
import {
    TYPE_REVIEW,
    ATTACHMENT_TITLE_MAP,
    ATTACHMENT_COLOR_MAP,
    ROLE_ADMIN,
    DATE_TIME_FORMAT,
    ROLE_CHIEF_EDITORIAL,
} from 'Constants';
import { aclDecorator } from 'Decorators';
import moment from 'moment';

@connect(store => ({
    loading: store.submissionData.loading,
    success: store.submissionData.success,
    error: store.submissionData.error,
    data: store.submissionAttachments.data,
    filter: store.submissionAttachments.filterList
}), dispatch => ({
    loadVersionHistoryData: (filter) => dispatch(loadVersionHistoryData(filter)),
    downloadFile: (fileId, title, saveToLog) => dispatch(downloadFile(fileId, title, saveToLog)),
}))
@aclDecorator()
export default class VersionHistoryList extends PureComponent {
    /**
     * PropTypes
     */
    static propTypes = {
        loadVersionHistoryData: PropTypes.func.isRequired,
        downloadFile: PropTypes.func.isRequired,
        submissionId: PropTypes.any.isRequired,
        data: PropTypes.array,
        filter: PropTypes.object,
        is: PropTypes.func.isRequired,
    };

    /**
     * Component Did Mount
     */
    componentDidMount() {
        const { loadVersionHistoryData, submissionId, filter } = this.props;
        loadVersionHistoryData(filter.merge({
            has: {'submission': {
                where: {'submissions.id': submissionId},
            }}
        }));
    }

    handleDownload(event, fileId, fileTitle) {
        event.preventDefault();
        const { downloadFile, is } = this.props;
        downloadFile(fileId, fileTitle, !is(ROLE_CHIEF_EDITORIAL));
    }

    render() {
        const { data, is } = this.props;

        return (
            <IconCard
                title={<FormattedMessage id={'form_groups.version_history'} />}
                backButton={
                    {
                        to: '/',
                        title: 'button.to.submissions'
                    }
                }
                content={
                    <Timeline
                        stories={ data.map((attachment) => {
                            const fileTitle = getAttachmentTitle(attachment);
                            return {
                                title: <FormattedMessage id={ ATTACHMENT_TITLE_MAP[attachment.type] }/>,
                                titleColor: ATTACHMENT_COLOR_MAP[attachment.type],
                                body:
                                    <a href='#' onClick={ (e) => this.handleDownload(e, attachment.id, fileTitle) } >
                                        { fileTitle }
                                    </a>,
                                footer:
                                    <div>
                                        <a href={is(ROLE_ADMIN) ? `/users/${attachment.user_id}` : null} target='_blank' >
                                            { attachment.user.name }
                                        </a>
                                        { ': ' + moment(attachment.created_at).format(DATE_TIME_FORMAT) }
                                    </div>,
                                inverted: [TYPE_REVIEW].includes(attachment.type)
                            };
                        }) }
                        classes={{timeline: 'timeline-vh-wrap'}}
                    />
                }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/SubmissionManagement/components/VersionHistoryList.jsx